import styled from 'styled-components';

export const Container = styled.div`
  color: ${({ theme }) => theme.colors[600]};

  .pagination {
    display: flex;
    list-style: none;
    align-items: center;
    gap: 0.2rem;
    margin-right: 1rem;
  }

  .previous {
    a {
      border: none !important;
    }
  }
  .previous.disabled {
    a {
      border: none !important;
    }
  }
  .next {
    a {
      border: none !important;
    }
  }

  .page,
  .break,
  .previous,
  .next {
    a {
      background-color: ${({ theme }) => theme.colors[1300]};
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
      display: grid;
      place-items: center;
      border: 1px solid ${({ theme }) => theme.colors.gray200};
      transition-property: filter, background-color, border-color;
      transition-duration: 0.3s;
      cursor: pointer;
      font-size: 0.75rem;

      :hover {
        filter: brightness(95%);
      }
      :active {
        filter: brightness(90%);
      }
    }

    &.active a {
      background-color: ${({ theme }) => theme.colors.tertiary};
      border-color: ${({ theme }) => theme.colors.tertiary};
      pointer-events: none;
      color: ${({ theme }) => theme.colors[1300]};
    }

    &.disabled a {
      cursor: not-allowed;
      cursor: not-allowed;
      :hover {
        filter: none;
      }
      :active {
        filter: none;
      }
    }
  }

  a {
    color: ${({ theme }) => theme.colors.gray200};
    font-weight: 600;
  }
`;
